/*
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  返回: 'Return',
  点击退出全屏模式: 'Click to exit fullscreen mode',
  点击切换全屏模式: 'Click to switch fullscreen mode',
  语言: 'Language',
  清除缓存: 'Clear cache',
  复制租户: 'Copy tenant',
  退出: 'Exit',
  搜索布局名称: 'Search for the layout name',
  分配布局: 'Assign layouts',
  新建布局: 'Create a new layout',
  列表页布局: 'List page layout',
  新建页布局: 'Create a new page layout',
  编辑页布局: 'Edit the page layout',
  详情页布局: 'Detail page layout',
  布局名称: 'The name of the layout',
  布局类型: 'Layout type',
  关联视图: 'Associated view',
  视图名称: 'View name',
  资源库: 'Resource library',
  请输入布局名称: 'Please enter a layout name',
  选择字段: 'Select field',
  可选字段: 'Optional field',
  列表页字段: 'List page field',
  拖到这里: 'Drag it here',
  置顶固定字段: 'Fixed field',
  以上指标将横向固定: 'Lateral fixation',
  筛选字段: 'Filter field',
  下拉搜索字段: 'Drop down the search field',
  列表页排序规则: 'List page sorting rules',
  新增排序规则: 'New sort rule',
  升序: 'Ascending order',
  降序: 'Descending order',
  请输入搜索内容: 'Please enter your search',
  添加新分组: 'Add new group',
  至少添加一个分组: 'Add at least one group！',
  请完善组件的必填内容: 'Please complete the required content of the component',
  请在子表单中至少添加一个自定义字段: 'Please add at least one custom field in the subform!',
  每个布局中最多只能添加10个子表单: 'Each layout can only add up to 10 subform!',
  组件: 'module',
  关联对象表格: 'Associated object table',
  关联记录: 'Associated records',
  查询记录: 'Query records',
  快速创建: 'Quick create',
  已完成关联主键创建: 'Associated primary key creation completed',
  关联对象字段: 'Associated object field',
  外链容器: 'External Link Container',
  未命名分组: 'Unnamed group',
  示例: 'Give an example',
  属于当前值: 'Belong to current value',
  添加显示条件: 'Add display condition',
  添加必填条件: 'Add required condition',
  数据范围条件配置: 'Data range condition configuration',
  条件配置: 'Condition configuration',
  数据条件设置不可为空: 'Data condition settings cannot be empty',
  详情标题: 'Detail title',
  请选择标题: 'Please select a title',
  点击配置是否展示商机阶段: 'Click to configure whether to show business stage',
  点击配置是否展示协作人: 'Click to configure whether to display collaborators',
  点击配置是否展示动态记录: 'Click to configure whether to show follow-up records',
  页签设置: 'Tab settings',
  是否展示: 'Whether to display',
  页签名称: 'Tab name',
  请输入页签名称: 'Please enter the tab name',
  显示条件: 'Display conditions',
  请选择显示条件: 'Please select a display condition',
  默认可见: 'Visible by default',
  满足条件可见: 'Visible when conditions are met',
  添加条件: 'Add condition',
  关联对象: 'Linked object',
  请选择关联对象: 'Please choose a linked object',
  请输入标题名称: 'Please input label name',
  至少保留一项可用于在表格内展示的字段: 'At least one field can be used for display in the table',
  字段配置: 'Field configuration',
  列表字段: 'List field',
  列表字段配置: 'List field configuration',
  已配置字段个数: 'Already configured：{number} fields',
  标题名称: 'Title',
  快捷按钮: 'Quick Button',
  表格字段配置: 'Table field configuration',
  展示字段配置: 'Display field configuration',
  数据范围: 'Data range',
  请选择数据范围: 'Please select a data range',
  数据条件范围配置: 'Data condition range configuration',
  关联主键: 'Related primary key',
  请选择关联主键: 'Please select the related primary key',
  显示字段: 'Display field',
  请选择显示字段: 'Please select a display field',
  请选择弹窗显示字段: 'Please select the pop-up display field',
  字段提示: 'Field prompts',
  请输入字段提示信息: 'Please enter the field prompt information',
  附加说明: 'Additional description',
  请输入附加说明信息: 'Please enter the attachment description information',
  是否展示整行: 'Whether to display the whole line',
  是否必填: 'Is it mandatory',
  请选择是否必填: 'Please choose whether it is mandatory',
  编辑页可修改: 'Editable on the edit page',
  编辑规则设置: 'Edit rule settings',
  可编辑已有记录: 'Allowed to edit existing records',
  可删除已有记录: 'Allowed to delete existing records',
  可新增记录: 'Allowed to add records',
  可插入记录: 'Allowed to insert records',
  默认提示文本: 'Default prompt text',
  请输入默认提示文本: 'Please enter the default prompt text',
  '设为只读的字段将不允许被用户直接编辑。但仍可以在自动化流程或导入时填写或更新': 'Fields set as read-only will not be allowed to be directly edited by users. But it can still be filled in or updated during automated processes or imports',
  '设为隐藏的字段将不会显示。但仍可以在自动化流程或导入时填写或更新': 'Fields set as hidden will not be displayed. But it can still be filled in or updated during automated processes or imports',
  是否整行展示: 'Whether to display the whole line',
  默认值: 'Default value',
  非必填: 'Not mandatory',
  必填: 'Mandatory',
  在某条件下必填: 'Mandatory under certain conditions',
  不展示默认值: 'Do not display the default value',
  展示统一默认值: 'Show uniform default value',
  自定义: 'customize',
  查询他表: 'Query his table',
  计算公式: 'calculation formula',
  查询他表配置: 'Query his table configuration',
  公式配置: 'Formula configuration',
  请选择表单: 'Please select a form',
  高级筛选: 'Advanced screening',
  请选择条件: 'Please select criteria',
  查询到多条时: 'When multiple items are queried',
  设置排序: 'Set sorting',
  当前用户: 'Current user',
  当前用户所属部门: 'The department to which the current user belongs',
  全部数据: 'All data',
  条件范围数据: 'Conditional range data',
  新增页签: 'Add tab',
  请输入分组名称: 'Please enter the group name',
  已选字段: 'Selected field',
  该页面不支持配置: 'This page does not support configuration',
  修改密码: 'Change Password',
  切换登录身份: 'Switch Login Identity',
  容联设置: 'Ronglian Settings',
  欢迎登录烽火: 'Welcome to log in to FiberHome',
  '温馨提示：为了您的账号考虑，请尽快修改登录密码~': 'Kind reminder: For the sake of your account, please change your login password as soon as possible~',
  暂不提示: "Don't prompt for now",
  稍后再说: "Let's talk later",
  立即修改: 'Modify Now',
  智书: 'Zhishu',
  赋值规则: 'Assignment rule',
  规则配置: 'Rule configuration',
  添加规则: 'Add rule',
  的: "'s",
  赋值给本对象的: 'change the value of the object',
  用户填写: 'When the user fills in',
  用户修改: 'When the user modifies',
  用户清空: 'When the user clears',
  '字段时，【逻辑赋值】自动覆盖【手动填写】': 'field,according to the assignment rule, all fields are automatically overlay',
  '字段时，将根据赋值规则，对所有字段重新赋值': 'field,according to the assignment rule, all fields are automatically overwritten',
  '字段时，将根据赋值规则，对所有字段同时清空': 'field,according to the assignment rule, all fields are automatically cleared',
  '字段时，已赋值字段不清空': 'field, the fields that have been assigned will not be cleared',
  切换语言: 'Switch language',
  新增: 'Add',
  编辑: 'Edit',
  多层级表格: 'A multi-level table',
  开启多层级表格: 'Open a multi-level table',
  添加多层级表格: 'Add a multi-level table',
  已添加二级表格: 'A secondary table has been added',
  已添加三级表格: 'A Level 3 table has been added',
  '请在查询记录中添加多层级表格！': 'Add a multi-level table to the table of query records!',
  '请配置多层级表格的关联对象!': 'Configure the associated objects for the multi-level table!',
  '删除二级表格将同步删除已配置的三级表格!': 'Deleting Level 2 tables will synchronize the deletion of configured level 3 tables!',
  从新建页布局复制: 'Copy from New Page Layout',
  从编辑布局复制: 'Copy from Edit Layout',
  '不复制，直接新建': 'Do not copy, create a new one directly',
  请选择: 'Please select',
  请选择布局: 'Please select a layout',
  冻结: 'Freeze',
  取消冻结: 'Unfreeze',
  批量修改: 'Multiple Modification',
  请选择需要修改的字段: 'Please select the field to be modified',
  修改为: 'Modify to',
  新值: 'New value',
  清空内容: 'Clear content',
  请完善修改后的值: 'Please complete the modified value',
  '你确定要修改全部数据吗？': 'Would you like to modify all data?',
  此操作将修改全部: 'This operation will modify all',
  '条数据。数据修改后不可恢复，请谨慎操作': 'data. Data cannot be restored after modification. Please operate carefully.',
  '此数据存在重复，请检查后重试': 'This data exists. Please check and try again.',
  置顶: 'Top up',
  取消置顶: 'Cancel top',
  复制到其他布局: 'Copy to other layouts',
  请选择页签名称: 'Please select a tab name',
  请选择目标页签: 'Please select the target tab',
  复制到当前布局: 'Copy to current layout',
  复制到当前页签: 'Copy to current tab',
  展示当前时间: 'Display the current time',
  复制到其他页签: 'Copy to other tabs',
  请选择目标布局: 'Please select the target layout',
  目标布局: 'Target layout',
  移动到分组: 'Move to Group',
  目标页签: 'Target tab',
  移动: 'Move',
  复制到其他布局页签: 'Copy to other layout tabs',
  恢复: 'restore',
  确定删除当前字段以及该字段对应表单数据: 'Are you sure to delete the current field and its corresponding form data',
  确定恢复当前字段以及该字段对应表单数据: 'Confirm to restore the current field and its corresponding form data',
  请确定最新的字段属性: 'Please confirm the latest field properties',
  布局字段列数: 'Layout Field Column Count',
  字段宽度: 'field width',
  批量恢复: 'Batch Recovery',
  检索定位: 'Retrieve and locate',
  请选择字段宽度: 'Please select field width',
  '确定批量恢复所选字段以及所选字段对应表单数据？': 'Are you sure to batch recover the selected fields and their corresponding form data?',
  显示设置: 'Display Settings',
  操作设置: 'Operation settings',
  '如不指定，默认按照数据创建时间降序排序': 'If not specified, the data will be sorted in descending order by default based on the creation time of the data',
  显示列: 'Display columns',
  列表下拉搜索: 'List dropdown search',
  多层级列表: 'Multi level List',
  默认排序规则: 'Default sorting rule',
  添加排序规则: 'Add sorting rules',
  搜索字段配置: 'Search field configuration',
  列表页展示至少需保留一个非子表单字段: 'List page display must retain at least one non sub form field',
  以上字段已冻结: 'The above fields have been frozen',
  '最多冻结10个非子表单类型的字段!': 'Freeze up to 10 fields that are not sub form types!',
  摘要区暂无内容: 'There is currently no content in the abstract area',
  暂无内容: 'No content available at the moment',
  校验: 'Verification',
  属性: 'Property',
  新建页: 'New page',
  编辑页: 'Edit page',
  详情页: 'Detail page',
  列表页: 'List page',
  高级配置: 'Advanced Configuration',
  请选择默认值: 'Please select default value',
  同步至协作人: 'Synchronize to collaborators'
};
